var map = {
	"./MOTOR.svg": "2baf",
	"./crane-truck.png": "f5e7",
	"./logo-light-icon.png": "6ec0",
	"./page-not-found.jpg": "23d8",
	"./storm.png": "6662",
	"./windscreen.png": "b054"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "bb6e";